var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.572V16a3.5 3.5 0 11-2-3.163v-4.41L9 11.7V19a3.5 3.5 0 11-2-3.163V6.3l13-4.728zm-11 8L18 6.3V4.428L9 7.7v1.872zm7.5 4.928a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-11 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDEuNTcyMjdWMTZDMjAgMTcuOTMzIDE4LjQzMyAxOS41IDE2LjUgMTkuNUMxNC41NjcgMTkuNSAxMyAxNy45MzMgMTMgMTZDMTMgMTQuMDY3IDE0LjU2NyAxMi41IDE2LjUgMTIuNUMxNy4wMzY4IDEyLjUgMTcuNTQ1NCAxMi42MjA4IDE4IDEyLjgzNjhWOC40Mjc2N0w5IDExLjcwMDRWMTlDOSAyMC45MzMgNy40MzMgMjIuNSA1LjUgMjIuNUMzLjU2NyAyMi41IDIgMjAuOTMzIDIgMTlDMiAxNy4wNjcgMy41NjcgMTUuNSA1LjUgMTUuNUM2LjAzNjggMTUuNSA2LjU0NTM3IDE1LjYyMDggNyAxNS44MzY4VjYuMjk5NTRMMjAgMS41NzIyN1pNOSA5LjU3MjI3TDE4IDYuMjk5NTRWNC40Mjc2N0w5IDcuNzAwMzlWOS41NzIyN1pNMTYuNSAxNC41QzE3LjMyODQgMTQuNSAxOCAxNS4xNzE1IDE4IDE2QzE4IDE2LjgyODQgMTcuMzI4NCAxNy41IDE2LjUgMTcuNUMxNS42NzE2IDE3LjUgMTUgMTYuODI4NCAxNSAxNkMxNSAxNS4xNzE1IDE1LjY3MTYgMTQuNSAxNi41IDE0LjVaTTUuNSAxNy41QzYuMzI4NDMgMTcuNSA3IDE4LjE3MTUgNyAxOUM3IDE5LjgyODQgNi4zMjg0MyAyMC41IDUuNSAyMC41QzQuNjcxNTcgMjAuNSA0IDE5LjgyODQgNCAxOUM0IDE4LjE3MTUgNC42NzE1NyAxNy41IDUuNSAxNy41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };